import script from "./Slider.vue?vue&type=script&setup=true&lang=ts"
export * from "./Slider.vue?vue&type=script&setup=true&lang=ts"

import "./Slider.vue?vue&type=style&index=0&id=b967eb46&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b967eb46"]])

export default __exports__